import { useCallback, useEffect, useState } from "react";
import { VerticalAlignTopOutlined } from "@ant-design/icons";
import "./styles.scss";

const ScrollToTop = () => {
	const [isGoTop, setIsGoTop] = useState(false);

	const handleGoToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	useEffect(() => {
		const checkScrollHeight = () => {
			if(window.scrollY > 80) {
				setIsGoTop(true);
			} else if(window.scrollY <= 80) {
				setIsGoTop(false);
			}
		};
		window.addEventListener("scroll", checkScrollHeight);
		return () => window.removeEventListener("scroll", checkScrollHeight);
	}, [isGoTop]);

	return (
		<div onClick={handleGoToTop} className={`${isGoTop && "showButton"} scrollTop`}>
			<VerticalAlignTopOutlined />
		</div>
	);
};

export default ScrollToTop;
